/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_ea17c9b8"]'><div><cube-button @_click="showPicker">use-subtitle</cube-button><cube-picker-popup ref="__mpx_ref_picker__" title="主标题" subtitle="子标题" :list="(dataList)" cancelTxt="取消" :selected-index="(selectedIndex)" confirmTxt="确认"/></div></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_ea17c9b8"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_ea17c9b8"}
  /** script content **/
  require("./subtitle-picker.mpx.js?isComponent&outputPath=components%2Fsubtitle-pickerea17c9b8%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./subtitle-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fsubtitle-pickerea17c9b8%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_ea17c9b8"],
    ctorType: "component",
    outputPath: "components/subtitle-pickerea17c9b8/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-picker-popup':getComponent(require("../../../packages/mpx-cube-ui/src/components/picker-popup/index.mpx?isComponent&outputPath=components%2Findex57353298%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>